import { FunctionGroupInterface } from "../../../common/interfaces/FunctionGroupInterface";
import { SelectFieldType } from "../../../common/types/Types";

export const getFunctionGroupOptions = (
    functionGroupData?: FunctionGroupInterface[],
): SelectFieldType[] => {
    if (!functionGroupData) {
        return [];
    }

    return functionGroupData.map((functionGroup) => ({
        value: functionGroup.id.toString(),
        label: functionGroup.name,
    }));
};
